import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import FileUploader from "../../../../components/shared/uploader/FileUploader";

const validationSchema = Yup.object().shape({});

const ContractorProjectPlantConstructionModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/SLN/Contractor/ProjectPlantConstruction");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data.substation, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "SLN/Contractor/ProjectPlantConstruction",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${data?.projectPlantConstruction}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.projectPlantConstruction}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                          name="mountStructureInstallation"
                          value={values.mountStructureInstallation}
                          checked={values.mountStructureInstallation}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="mountStructureInstallation"
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                          name="dcElectricalInstallation"
                          value={values.dcElectricalInstallation}
                          checked={values.dcElectricalInstallation}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="dcElectricalInstallation"
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                          name="acElectricalInstallation"
                          value={values.acElectricalInstallation}
                          checked={values.acElectricalInstallation}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="acElectricalInstallation"
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={6}>
                        <FormControlLabel
                          name="initialCommissioning"
                          value={values.initialCommissioning}
                          checked={values.initialCommissioning}
                          onChange={wrapFormikHandleChange(handleChange)}
                          control={<Switch />}
                          label="initialCommissioning"
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          label="توضیحات"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("description")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <FileUploader
                          moduleName={"SLN/Contractor"}
                          maxFiles={1}
                          label="فایل قرارداد "
                          onChange={(list) => {
                            console.log(list);

                            if (list.length > 0) {
                              setFieldValue("contractFileUrl", list[0]);
                            } else {
                              setFieldValue("contractFileUrl", "");
                            }
                          }}
                          baseurl={data.baseUrl}
                          placeholder={"فایل مورد نظر را انتخاب کنید"}
                          {...onMakeFormikVariable("contractFileUrl")}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContractorProjectPlantConstructionModifyPage;
